var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.ad_config.is_enabled)?_c('external-ad-iframe',{attrs:{"external_ad_id":_vm.ad_config.external_id}}):_c('nsw-banner',{ref:"nsw"}),_vm._v(" "),_c('nsw-menu'),_vm._v(" "),_c('div',{staticClass:"content-wrapper updated-2026"},[_c('nsw-module',{staticClass:"nsw-module"}),_vm._v(" "),_c('nsw-news',{staticClass:"nsw-news"})],1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ef93584","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Home.vue
// module id = SVv/
// module chunks = 2 3 4 5 6